module.exports = __webpack_public_path__ + "static/media/logo.634e7348.png";